import { createWebHistory, createRouter } from 'vue-router';
import config from '@/config/router';
import beforeEach from '@/middleware/beforeEachRoute';

import routes from '@/routes';

const router = createRouter({
    ...config,
    routes,
    history: createWebHistory(),
});

// FIXME load from middleware .... i.e. move to middleware
router.beforeEach(beforeEach);

export default router;
